<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-10">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a [routerLink]="['/home']">Home</a></li>
      <li class="breadcrumb-item"><a [routerLink]="['/smart-irrigation/regions']">Smart Irrigation</a></li>
      <li class="breadcrumb-item active"><strong>Administration</strong></li>
    </ol>
  </div>
</div>

<div class="wrapper wrapper-content animated fadeInRight pt-3">

  <div class="at-header">
    <div>
      <div class="at-title">Node Structure</div>
      <div class="at-subtitle">Organise your irrigation zones into a hierarchy of nodes.</div>
    </div>
    <button class="at-refresh-btn"
            (click)="refreshTree()"
            [disabled]="isLoading"
            title="Refresh">
      <i class="fa fa-sync" [class.fa-spin]="isLoading"></i>
    </button>
  </div>

  <!-- Loading state -->
  <div class="at-loading" *ngIf="isLoading">
    <span class="at-spinner"></span> Loading node structure&hellip;
  </div>

  <!-- Error state -->
  <div class="at-error" *ngIf="!isLoading && loadError">
    <i class="fa fa-exclamation-triangle"></i>
    Failed to load node structure.
    <a (click)="refreshTree()" class="at-error__link">Try again</a>.
  </div>

  <!-- Empty state -->
  <div class="at-empty" *ngIf="!isLoading && !loadError && !rootNode">
    <i class="fa fa-sitemap"></i>
    <p>No node structure found.</p>
  </div>

  <!-- Tree -->
  <div class="at-card" *ngIf="!isLoading && rootNode">
    <app-node-tree-item
      [node]="$any(rootNode)"
      [customerId]="app.customerId"
      [isRoot]="true"
      [geoAssets]="geoAssets"
      (nodeChanged)="onNodeChanged($event)">
    </app-node-tree-item>
  </div>

</div>